<div class="display-flex">
  <div class="col-md-6">
    <!-- <h4 mat-dialog-title style="font-weight: bold;">{{title}}</h4> -->
  </div>
  <div class="col-md-6 text-right p-4">
    <a href="javascript:" mat-dialog-close><i class="fa fa-times-circle text-secondary"></i></a>
  </div>
</div>
<div class="popup">
  <video controls (canplay)="pauseVideo(videoplayer)" #videoPlayer style="width: 880px; min-height: 480px;">
    <source [src]="videoSource" type="video/mp4">
    Your browser does not support the video tag.
  </video>
</div>